export type IteroBrowserTab = 'patients' | 'orders';

export const BROWSER_TABS: readonly { readonly id: IteroBrowserTab; readonly label: string }[] = [
    { id: 'patients', label: 'Patients' },
    { id: 'orders', label: 'Orders' }
];

export const tabId = (baseId: string, tab: IteroBrowserTab) => `${baseId}-tab-${tab}`;
export const panelId = (baseId: string, tab: IteroBrowserTab) => `${baseId}-panel-${tab}`;
